import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Star } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-muted/30 flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center mx-auto mb-6">
          <Star className="w-8 h-8 text-primary-foreground" />
        </div>
        <h1 className="text-6xl font-bold text-primary mb-2">404</h1>
        <h2 className="text-xl font-semibold mb-2">Seite nicht gefunden</h2>
        <p className="text-muted-foreground mb-6">
          Die angeforderte Seite existiert nicht oder wurde verschoben.
        </p>
        <Link to="/">
          <Button>Zur Startseite</Button>
        </Link>
      </div>
    </div>
  );
}
